import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import { getCdsMenuProfile } from '@/services/commerce-api/cdsMenuProfile';
import oro from 'images/brands-unique/cds/tier-oro.webp';
import platino from 'images/brands-unique/cds/tier-platino.webp';
import diamante from 'images/brands-unique/cds/tier-diamante.webp';
import './CdsPointsPricingRow.scss';

const icons = { oro, platino, diamante };

/**
 * Display the persisted points selection without changing the monetary total.
 * @param {object} props - Row properties.
 * @param {string|number} props.amount - Exact points amount saved by Purchase.
 * @param {boolean} props.earned - Whether the amount is an informational earned reward.
 * @param {boolean} props.redeemed - Whether the amount was already consumed.
 * @returns {React.ReactElement} Points deduction and optional account tier icon.
 */
export default function CdsPointsPricingRow({ amount, redeemed = false, earned = false }) {
  const user = useSelector((state) => state.reserhubAccount?.get('user'));
  const environment = useWhitelabelEnvs();
  const scope = JSON.stringify([environment.reserhub?.api?.baseUrl, user?.id, user?.sessionToken]);
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (user?.id) {
      getCdsMenuProfile(scope)
        .then((result) => {
          if (!cancelled) setProfile({ scope, category: result?.category });
        })
        .catch(() => {
          if (!cancelled) setProfile(null);
        });
    }
    return () => {
      cancelled = true;
    };
  }, [scope, user?.id]);
  const category = profile?.scope === scope ? profile.category?.trim().toLowerCase() : null;
  let label = redeemed ? 'CASH CDS usados' : 'Cash a usar';
  if (earned) label = 'CASH CDS obtenidos';
  return (
    <div className={`cds-points-pricing-row${earned ? ' cds-points-pricing-row--earned' : ''}`}>
      <span className="cds-points-pricing-row__label">
        {icons[category] && <img src={icons[category]} alt={`Categoría ${category}`} />}
        {label}
      </span>
      <span className="cds-points-pricing-row__amount">
        {earned ? '+' : '-'} S/ {amount}
      </span>
    </div>
  );
}

CdsPointsPricingRow.propTypes = {
  redeemed: PropTypes.bool,
  earned: PropTypes.bool,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
